<template>
  <el-dialog :title="dataForm.id ? 'Edit Supplier' : 'Add Supplier'" :close-on-click-modal="false" :visible.sync="visible" width="900px" top="2vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-position="top">
      <el-row :gutter="10">
        <el-col :span="24">
          <copy-from
            :dataForm="dataForm"
            :options="supplierList"
            :labelFormatter="item => `${item.abbr}-${item.companyName}`"
            @copyFromTrigger="copyFromTrigger"
          />
        </el-col>
        <el-col :span="12">
          <el-form-item label="Abbreviation" prop="abbr">
            <el-input v-model="dataForm.abbr" clearable placeholder="e.g. EStar"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Invoice Prefix" prop="invoiceNumberPrefix">
            <el-input v-model="dataForm.invoiceNumberPrefix" clearable placeholder="e.g. ESTAR-"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Company Name" prop="companyName">
            <el-input v-model="dataForm.companyName" clearable placeholder="Full legal name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Registration No." prop="registrationNo">
            <el-input v-model="dataForm.registrationNo" clearable placeholder="e.g. 201917568E"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Country" prop="country">
            <el-select v-model="dataForm.country" filterable clearable placeholder="Country" class="wdb100">
              <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Billing Address" prop="billingAddress">
            <el-input v-model="dataForm.billingAddress" clearable placeholder="Street address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Post Code" prop="postCode">
            <el-input v-model="dataForm.postCode" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Email" prop="email">
            <el-input v-model="dataForm.email" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Default Invoice Template">
            <div class="pt20 invoiceTemplateWrap">
              <div class="wdb100 customElFormItem" v-for="(item, idx) in dataForm.defaultInvoiceTemplates" :key="item.businessGenre">
                <el-form-item :label="item.businessLabel" :prop="`defaultInvoiceTemplates.${idx}.invoiceTemplateId`">
                  <el-select v-model="item.invoiceTemplateId" clearable filterable placeholder="Select Template" class="wdb100">
                    <el-option v-for="item in invoiceTemplateList" :key="item.id" :label="item.templateName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Company Logo" prop="companyLogoUrl">
            <div class="imageArea">
              <el-image-uploader v-model="dataForm.companyLogoUrl"></el-image-uploader>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="Tax Types"
            prop="taxInfos"
            :rules="{
              type: 'array',
              required: !dataForm.hasNoTax,
              message: 'please add',
              trigger: 'submit',
            }"
          >
            <div class="taxTypeWrap">
              <div class="checkboxWrap">
                <el-checkbox v-model="dataForm.hasNoTax" :true-label="1" :false-label="0" @change="hasNoTaxChange">No Tax (N/A)</el-checkbox>
              </div>
              <div class="wdb100 fs0 lh0">
                <div class="wdb100" v-for="(item, index) in dataForm.taxInfos" :key="`taxType-${index}`">
                  <el-row :gutter="10">
                    <el-col :span="16">
                      <el-form-item
                        :prop="`taxInfos.${index}.taxType`"
                        :rules="{
                          required: true,
                          message: 'please enter',
                          trigger: 'submit',
                        }"
                      >
                        <el-input v-model="item.taxType" clearable placeholder="Tax type" :disabled="!!dataForm.hasNoTax"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        :prop="`taxInfos.${index}.taxRate`"
                        :rules="{
                          required: true,
                          message: 'please enter',
                          trigger: 'submit',
                        }"
                        class="flexItem"
                      >
                        <el-input-number
                          v-model="item.taxRate"
                          :precision="2"
                          :min="0"
                          controls-position="right"
                          placeholder="Rate %"
                          :disabled="!!dataForm.hasNoTax"
                          class="tal wdb100"
                        ></el-input-number>
                        <span class="ml4">%</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="2" class="tac">
                      <el-button type="danger" size="small" icon="el-icon-delete" plain @click="deleteHandle(index)"></el-button>
                    </el-col>
                  </el-row>
                </div>
                <el-button type="primary" icon="el-icon-plus" size="mini" plain :disabled="!!dataForm.hasNoTax" @click="addHandle">Add Tax Type</el-button>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { multiply, divide } from "@/utils/count";
import CopyFrom from "@/components/CopyFrom";
export default {
  props: {
    supplierList: {
      type: Array,
      default: () => [],
    },
    invoiceTemplateList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        id: null,
        abbr: "",
        invoiceNumberPrefix: "",
        companyName: "",
        registrationNo: "",
        country: "",
        billingAddress: "",
        postCode: "",
        email: "",
        defaultInvoiceTemplates: [],
        companyLogoUrl: {},
        hasNoTax: 0,
        taxInfos: [],
      },
      dataRule: {
        abbr: [{ required: true, message: "please enter", trigger: "submit" }],
        invoiceNumberPrefix: [{ required: true, message: "please enter", trigger: "submit" }],
        companyName: [{ required: true, message: "please enter", trigger: "submit" }],
        country: [{ required: true, message: "please select", trigger: "submit" }],
        email: [{ type: "email", message: "please provide a valid email address", trigger: "submit" }],
        // companyLogoUrl: [
        //   {
        //     type: "object",
        //     required: true,
        //     fields: {
        //       url: { required: true, message: "please upload", trigger: "submit" },
        //     },
        //   },
        // ],
      },
      submitLoading: false,
    };
  },
  components: {
    CopyFrom,
  },
  computed: {
    ...mapState("constant", ["countryList", "entityTypes"]),
  },
  methods: {
    async init(data) {
      this.visible = true;
      this.submitLoading = false;
      // 需要手动设置taxInfos为[],不然会报错
      this.$set(this.dataForm, "taxInfos", []);
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      // 根据entityTypes设置defaultInvoiceTemplates列表
      const defaultInvoiceTemplates = this.defaultInvoiceTemplatesFormat(data);
      if (data) {
        const dataCopy = JSON.parse(JSON.stringify(data));
        // 回显时将真实税率乘以100得到百分比税率
        let taxInfos = [];
        if (dataCopy.hasNoTax || !dataCopy.taxInfos) {
          taxInfos = [];
        } else {
          taxInfos = dataCopy.taxInfos.map(item => ({
            ...item,
            taxRate: multiply(item.taxRate, 100),
          }));
        }
        this.dataForm = {
          id: dataCopy.id,
          abbr: dataCopy.abbr,
          invoiceNumberPrefix: dataCopy.invoiceNumberPrefix,
          companyName: dataCopy.companyName,
          registrationNo: dataCopy.registrationNo,
          country: dataCopy.country,
          billingAddress: dataCopy.billingAddress,
          postCode: dataCopy.postCode,
          email: dataCopy.email,
          defaultInvoiceTemplates,
          companyLogoUrl: dataCopy.companyLogoUrl || {},
          hasNoTax: dataCopy.hasNoTax,
          taxInfos,
        };
      } else {
        this.$set(this.dataForm, "id", null);
        this.$set(this.dataForm, "defaultInvoiceTemplates", defaultInvoiceTemplates);
      }
    },
    // 表单提交
    async formSubmitRequest() {
      const params = {
        ...this.dataForm,
      };
      // 过滤掉已经不存在的发票模板
      params.defaultInvoiceTemplates = params.defaultInvoiceTemplates.filter(item => item.invoiceTemplateId);
      // 将税率(rate)百分比除以100后再提交
      params.taxInfos = params.taxInfos.map(item => ({
        ...item,
        taxRate: divide(item.taxRate, 100),
      }));
      if (params.id) {
        return await this.$http.put(`/admin/supplier/${params.id}`, params);
      } else {
        return await this.$http.post("/admin/supplier", params);
      }
    },
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest()
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
    // 添加
    addHandle() {
      this.dataForm.taxInfos.push({
        taxType: "",
        taxRate: undefined,
      });
    },
    // 删除
    deleteHandle(index) {
      this.dataForm.taxInfos.splice(index, 1);
    },
    // 接收复制完成的数据
    copyFromTrigger(originalData, newDataForm) {
      // 动态设置defaultInvoiceTemplates列表
      newDataForm.defaultInvoiceTemplates = this.defaultInvoiceTemplatesFormat(originalData);
      this.dataForm = newDataForm;
    },
    // 勾选(No Tax (N/A))后，清空Tax Types列表
    hasNoTaxChange(val) {
      if (val) {
        this.$set(this.dataForm, "taxInfos", []);
      }
    },
    // 动态设置defaultInvoiceTemplates列表
    defaultInvoiceTemplatesFormat(data) {
      const list = [];
      this.entityTypes.forEach(element => {
        const defaultInvoiceTemplates = data?.defaultInvoiceTemplates || [];
        const invoiceTemplateId = defaultInvoiceTemplates.find(item => item.businessGenre == element.value)?.invoiceTemplateId || null;
        list.push({
          businessLabel: element.title,
          businessGenre: element.value,
          invoiceTemplateId,
        });
      });
      return list;
    },
  },
};
</script>

<style lang="scss" scoped>
.imageArea {
  padding: 10px;
  border: 1.5px solid #d0e8f5;
  border-radius: 2px;
  font-size: 13px;
}

.invoiceTemplateWrap {
  padding: 16px 16px 0;
  border: 1.5px solid #d0e8f5;
  border-radius: 2px;

  .customElFormItem {
    ::v-deep {
      .el-form-item {
        display: flex;

        .el-form-item__label {
          font-weight: 400 !important;
          width: 160px !important;
          line-height: 36px !important;
        }

        .el-form-item__content {
          width: 100%;
          flex: 1;
        }
      }
    }
  }
}

.taxTypeWrap {
  padding: 10px;
  background: #f5f7fa;
  border-radius: 2px;
  position: relative;

  .checkboxWrap {
    position: absolute;
    top: -34px;
    right: 0px;

    ::v-deep {
      .el-checkbox {
        vertical-align: middle;

        .el-checkbox__label {
          font-size: 13px !important;
        }
      }
    }
  }

  .flexItem {
    ::v-deep {
      .el-form-item__content {
        display: flex;
      }
    }
  }
}
</style>
